module.exports = __webpack_public_path__ + "img/56.10.pH.db240c32.png";